// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._4cvr1h6o{align-items:center}\n._i0dl1kw7{flex-basis:inherit}\n._i0dl1ssb{flex-basis:50%}", ""]);
// Exports
module.exports = exports;
